import React, { forwardRef } from 'react'
import { bool, object } from 'prop-types'
import styled from 'styled-components'
import { useIntl } from 'react-intl'

import { userMenuMessages } from '../../../../../translations'
import { useAuthenticationState } from '../../../../../contexts/AuthenticationContext'
import { useNavContext } from '../../../../../contexts/NavContext'
import { Button } from '../../../../Button'
import FreshdeskWidget from '../../../../Freshdesk'

const StyledFreshdeskWidget = styled(FreshdeskWidget)`
  padding: 0.625rem 1.0625rem;
  font-weight: normal !important;
  background: transparent;
  border: none;
  display: flex;
  width: 100%;
  height: 100%;

  color: ${({ theme }) => theme.textColor} !important;

  &:hover {
    color: ${({ theme }) => theme.textColor} !important;
    cursor: pointer;
  }
`

const StyledButton = styled(Button)`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 0;

  div,
  span {
    display: flex;
    width: 100%;
    height: 100%;
  }
  font-size: 0.8125rem !important;
`

export const Freshdesk = forwardRef(({ campaign, withContext }, ref) => {
  const { user } = useAuthenticationState()
  const { formatMessage } = useIntl()
  const autofill = { email: user?.email, custom_fields: { cf_campaign: campaign?.name } }

  if (withContext) {
    return <FreshdeskWithContext autofill={autofill} ref={ref} />
  }
  return (
    <StyledButton as='div'>
      <StyledFreshdeskWidget autofill={autofill} ref={ref}>
        {formatMessage(userMenuMessages.help)}
      </StyledFreshdeskWidget>
    </StyledButton>
  )
})

export const FreshdeskWithContext = forwardRef(({ autofill }, ref) => {
  const { formatMessage } = useIntl()
  const { toggleMenu } = useNavContext()

  return (
    <StyledButton as='div'>
      <StyledFreshdeskWidget
        close={() => {
          toggleMenu
        }}
        autofill={autofill}
        ref={ref}
      >
        {formatMessage(userMenuMessages.help)}
      </StyledFreshdeskWidget>
    </StyledButton>
  )
})

Freshdesk.defaultProps = {
  withContext: false,
}

Freshdesk.propTypes = {
  campaign: object,
  withContext: bool,
}

FreshdeskWithContext.propTypes = {
  autofill: object,
}
